module.exports = __webpack_public_path__ + "static/media/yellow_car.88191750.png";